import React from 'react'
import InputAdornment from '@mui/material/InputAdornment'
import TextField from '@mui/material/TextField'
import {
    ColumnsPanelTrigger,
    QuickFilter,
    QuickFilterClear,
    QuickFilterControl,
    Toolbar,
} from '@mui/x-data-grid/components'
import { PropsFromSlot } from '@mui/x-data-grid/models'
import { Cancel, Search } from '@mui/icons-material'
import { GridSlots } from '@mui/x-data-grid-pro/DataGridPro'
import ViewColumnIcon from '@mui/icons-material/ViewColumn'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'

export interface CustomDataGridToolbarProps extends PropsFromSlot<GridSlots['toolbar']> {
    showSearchFilter: boolean
}

export const CustomDataGridToolbar = ({ showSearchFilter = true }: CustomDataGridToolbarProps) => {
    return (
        <Toolbar>
            <Box sx={{ justifyContent: 'space-between', py: 3, pl: 2, display: 'flex', width: '100%' }}>
                <QuickFilter expanded>
                    {showSearchFilter && (
                        <QuickFilterControl
                            render={({ ref, ...controlProps }, state) => (
                                <TextField
                                    {...controlProps}
                                    inputRef={ref}
                                    aria-label='Sök'
                                    placeholder='Sök...'
                                    size='small'
                                    slotProps={{
                                        input: {
                                            startAdornment: (
                                                <InputAdornment position='start'>
                                                    <Search fontSize='small' />
                                                </InputAdornment>
                                            ),
                                            endAdornment: state.value ? (
                                                <InputAdornment position='end'>
                                                    <QuickFilterClear
                                                        edge='end'
                                                        size='small'
                                                        aria-label='Rensa'
                                                        material={{ sx: { marginRight: -0.75 } }}
                                                    >
                                                        <Cancel fontSize='small' />
                                                    </QuickFilterClear>
                                                </InputAdornment>
                                            ) : null,
                                            ...controlProps.slotProps?.input,
                                        },
                                        ...controlProps.slotProps,
                                    }}
                                />
                            )}
                        />
                    )}
                </QuickFilter>

                <ColumnsPanelTrigger render={<Button color='primary' />}>
                    <ViewColumnIcon color='primary' fontSize='medium' sx={{ mr: 2 }} />
                    Anpassa kolumner
                </ColumnsPanelTrigger>
            </Box>
        </Toolbar>
    )
}
